import { createSlice } from '@reduxjs/toolkit'

export const pagerSlice = createSlice({
  name: 'page',
  initialState: {
    value: 1,
  },
  reducers: {
    increment: (state) => {
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    reset: (state) => {
        state.value = 1
    },
    setPagePayload : (state, action) => {
      state.value = action.payload
    }
  },
})

export const { increment, decrement, reset, setPagePayload } = pagerSlice.actions
export default pagerSlice.reducer